import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './styles/dashboard.css';

export default function dashBoard() {
  return (
    <>
      <div className="dashboard m-3">
        <Container>
          <Row className='dash_row'>
            <div className="dashboard_head d-flex justify-content-start mb-4">
              <h2>Dashboard</h2>
            </div>
            <div className="dash_content d-flex gap-5">
            <Col size={6}>
              <div className="left_dash">
                <div className="left_dash_content d-flex gap-4 align-items-center">
                  <span>Referrals</span>
                  <h4 className='m-0'>15</h4>
                </div>
              </div>
            </Col>
            <Col size={6}>
            <div className="right_dash">
                <div className="right_dash_content d-flex gap-4 align-items-center">
                  <span>Your Earnings(USDT)</span>
                  <h4 className='m-0'>0</h4>
                </div>
              </div>
            </Col>
            </div>
          </Row>
        </Container>
      </div>
    </>
  )
}
